import React, { useMemo, useState } from 'react';
import AppConfigContext from '../contexts/AppConfigContext';
import { IBaseAppConfig, ITenantAppConfig } from './types';
import { getAppConfig } from '../utils/appConfigHelper';

export default function AppConfigProvider<T extends IBaseAppConfig>(props: {
  tenantName: string;
  children: React.ReactNode;
}) {
  const AppConfigContextTag = useMemo(() => AppConfigContext<T>(), []);
  const [config] = useState<ITenantAppConfig<T>>(() =>
    getAppConfig<T>(props.tenantName)
  );

  return (
    <AppConfigContextTag.Provider value={config}>
      {props.children}
    </AppConfigContextTag.Provider>
  );
}
